import { useRouter } from 'next/router';
import Image from 'next/image';

import { H3 } from '@common/headline';
import { BodyRegular } from '@common/body';
import Button from '@common/Button/Button';
import { trackClickedGetQuiz } from '@nextUtils/trackingUtils';
import { ErrorTracking } from '@common/errorTracking';
import { getTakeOurHealthQuizLink } from '@nextUtils/guidesUtils';

import mounjaroPen from '@public/img/guides/mounjaro-pen.png';

export const ArticleCTA = ({
  utmMedium,
  utmCampaign,
  isTopCTA,
}: {
  utmMedium?: string;
  utmCampaign?: string;
  isTopCTA: boolean;
}): JSX.Element => {
  const { push } = useRouter();

  const handleCTAClick = (): void => {
    try {
      const utmContent = isTopCTA
        ? `guidesImageCTATop`
        : `guidesImageCTABottom`;

      trackClickedGetQuiz({
        ctaText: 'Check Eligibility Now',
        location: 'Guides',
        utmMedium,
        utmCampaign,
        utmContent,
      });

      const quizLink = getTakeOurHealthQuizLink(
        utmMedium,
        utmCampaign,
        'guides',
        utmContent,
      );

      push(quizLink);
    } catch (error) {
      ErrorTracking.track(error);
    }
  };

  return (
    <div className="mt-8 flex max-h-[413px] max-w-[424px] flex-row rounded-xl border border-dawn-blue p-4 sm:mt-10 sm:pb-6">
      <div className="flex w-5/6 flex-col justify-between pr-6">
        <H3>Medication-assisted weight loss with a future focus</H3>
        <div>
          <div className="my-4 text-mono-grey">
            <BodyRegular>
              Start with Mounjaro, transition to habit-based health with our
              support
            </BodyRegular>
          </div>
          <Button
            colour="NavyBlue"
            type="Primary"
            onPress={handleCTAClick}
            fullWidth
          >
            <div className="px-[-20px]">
              <BodyRegular>
                <span className="font-bold">Check Eligibility Now</span>
              </BodyRegular>
            </div>
          </Button>
        </div>
      </div>
      <div className="flex w-1/6 flex-row">
        <Image
          src={mounjaroPen}
          alt="Mounjaro pen"
          width={33.75}
          height={330}
          className="object-contain"
        />
      </div>
    </div>
  );
};
